// The last segment of a local path. Folder names may hold spaces ("Acme
// Tower"), and so may a file name: an extension marks where it ends ("Acme
// Confidential.rvt"), and without one the segment runs on through words that
// start with a capital or a digit ("Acme Tower Phase 2"), which is how folder
// names continue and how a sentence does not ("... is locked").
const SPACED_WORDS = String.raw`(?:[ \t]+[A-Z0-9][^\s"'<>|:*?\\/]*?(?=[\s"'<>|)\]]|[.,;:!?](?:\s|$)|$))*`;
const WINDOWS_PATH_TAIL = String.raw`(?:[^\\/"'<>|:*?\r\n]*?\.[A-Za-z0-9]{1,8}(?=[\s"'<>|,;:.)\]]|$)|[^\\/\s"'<>|:*?]+${SPACED_WORDS})`;
const POSIX_PATH_TAIL = String.raw`(?:[^/"'<>|:\r\n]*?\.[A-Za-z0-9]{1,8}(?=[\s"'<>|,;:.)\]]|$)|[^/\s"'<>|:]+${SPACED_WORDS})`;

const WINDOWS_PATH = new RegExp(
  String.raw`\b[A-Za-z]:[\\/](?:[^\\/"'<>|:*?\r\n]*?[\\/])*` +
    WINDOWS_PATH_TAIL,
  'g',
);
const UNC_PATH = new RegExp(
  String.raw`\\\\(?:[^\\/"'<>|:*?\r\n]*?\\)+` + WINDOWS_PATH_TAIL,
  'g',
);
const POSIX_PATH = new RegExp(
  String.raw`(?<![\w:/])/(?:Users|home|tmp|var|mnt|Volumes|private)/(?:[^/"'<>|:\r\n]*?/)*` +
    POSIX_PATH_TAIL,
  'g',
);

/**
 * Sanitizes text by removing PII before sending to analytics.
 * Strips email addresses, UUIDs, API keys, file paths and other sensitive
 * patterns.
 */
export function sanitizePII(text: string | undefined): string | undefined {
  if (!text) return undefined;

  return (
    text
      // Remove email addresses
      .replace(
        /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g,
        '[EMAIL]',
      )
      // Remove UUIDs (common in our error messages for IDs)
      .replace(
        /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/gi,
        '[ID]',
      )
      // Remove common API key patterns with known prefixes
      // More conservative than matching all long strings to preserve error context
      .replace(/\b(sk|pk|api|key)_[A-Za-z0-9_-]{16,}\b/gi, '[API_KEY]')
      // Remove local file paths: Windows drive paths, UNC paths, and POSIX
      // paths under a user or data directory. Host applications put the
      // model's file name in their error messages
      // ("C:\Projects\Acme Tower\customer.rvt").
      .replace(WINDOWS_PATH, '[PATH]')
      .replace(UNC_PATH, '[PATH]')
      .replace(POSIX_PATH, '[PATH]')
      // Remove phone numbers (basic patterns)
      .replace(/\b\d{3}[-.]?\d{3}[-.]?\d{4}\b/g, '[PHONE]')
      // Remove IP addresses (basic pattern - may match version numbers, which is acceptable)
      .replace(/\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/g, '[IP]')
  );
}
